import { ScreenListener } from 'mind-sdk-web';
import {
  MediaStreamAudioConsumer,
  MediaStreamAudioSupplier,
  MediaStreamVideoConsumer,
  MediaStreamVideoSupplier,
} from 'mind-sdk-web/lib/MediaStream';
import { Screen as MindScreen } from 'mind-sdk-web/lib/Screen';

type ScreenProps = {
  mindScreen: MindScreen;
};

export class Screen implements MediaStreamAudioSupplier, MediaStreamVideoSupplier {
  private mindScreen: MindScreen;

  private acquired: boolean = false;
  private acquiring: boolean = false;

  constructor(props: ScreenProps) {
    this.mindScreen = props.mindScreen;
  }

  isAcquired(): boolean {
    return this.acquired;
  }

  isAcquiring(): boolean {
    return this.acquiring;
  }

  async acquire(): Promise<void> {
    if (this.acquiring) {
      throw new Error('Screen is already acquiring');
    }

    this.acquiring = true;
    try {
      await this.mindScreen.acquire();
      this.acquired = true;
    } finally {
      this.acquiring = false;
    }
  }

  release(): void {
    if (!this.acquired) {
      return;
    }

    this.mindScreen.release();
    this.acquired = false;
  }

  setAudioCapturing(audioCapturing: boolean): void {
    this.mindScreen.setAudioCapturing(audioCapturing);
  }

  setFps(fps: number): void {
    this.mindScreen.setFps(fps);
  }

  setBitrate(bitrate: number): void {
    this.mindScreen.setBitrate(bitrate);
  }

  setListener(screenListener: ScreenListener): void {
    this.mindScreen.setListener(screenListener);
  }

  addAudioConsumer(consumer: MediaStreamAudioConsumer): void {
    this.mindScreen.addAudioConsumer(consumer);
  }

  removeAudioConsumer(consumer: MediaStreamAudioConsumer): void {
    this.mindScreen.removeAudioConsumer(consumer);
  }

  addVideoConsumer(consumer: MediaStreamVideoConsumer): void {
    this.mindScreen.addVideoConsumer(consumer);
  }

  removeVideoConsumer(consumer: MediaStreamVideoConsumer): void {
    this.mindScreen.removeVideoConsumer(consumer);
  }

  fireAudioBuffer(): void {
    this.mindScreen.fireAudioBuffer();
  }

  fireVideoBuffer(): void {
    this.mindScreen.fireVideoBuffer();
  }
}
